import DefaultProps from '../../commonTypes/defaultprops.types';
import React, { Dispatch, SetStateAction, ReactNode } from 'react';
import { BackdropProps } from '../Modal/Backdrop/backdrop.types';

export enum PopoverPlacement {
  LEFT = 'left',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
  RIGHT = 'right',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
  TOP = 'top',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
}

export enum ShowOnEvent {
  CLICK = 'click',
  HOVER = 'hover',
}

export interface PopoverProps extends DefaultProps {
  placement: PopoverPlacement;
  popoverContent: ReactNode;
  popoverOffset?: number[];
  showOnEvent?: ShowOnEvent;
  showMultiple?: boolean;
  preventOverflow?: boolean;
  overflowOverReference?: boolean;
  preventOverflowPadding?: number | object;
  flipPopover?: boolean;
  showArrow?: boolean;
  portalTarget?: HTMLElement;
  onOpen?: () => void;
  onClose?: () => void;
  closeOnPopperClick?: boolean;
  isOpen?: boolean;
  defaultIsOpen?: boolean;
  BackdropComponent?: React.ComponentType;
  backdropProps?: BackdropProps;
  enableBackdropClick?: boolean;
  enableScrollbarWidthOffset?: boolean;
  enableScrollLock?: boolean;
  enableBackdrop?: boolean;
}

export interface PopperComponentProps extends PopoverProps {
  referenceElement: HTMLElement | null;
  clickOutsidePopperHandler: () => void;
  popperClickHandler?: () => void;
}

export interface PopoverArrowProps extends DefaultProps {
  popperPosition: string | null;
  ref: Dispatch<SetStateAction<HTMLElement | null>>;
  arrowStyles?: React.CSSProperties;
}

export interface PopperWrapperProps extends DefaultProps {
  ref?: Dispatch<SetStateAction<HTMLElement | null>>;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

export interface ReferenceWrapperProps {
  ref?: Dispatch<SetStateAction<HTMLElement | null>>;
  isShowingBackdrop?: boolean;
}

export interface PopperContainerProps {
  isShowingBackdrop?: boolean;
}
